
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import MDButton from 'components/MDButton';
import Select from 'react-select';
import MDInput from "components/MDInput";
import React, { useState, useEffect } from "react";
// import { useParams } from 'react-router-dom';
import { Oval } from 'react-loader-spinner';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import * as moment from 'moment';
import { Checkbox } from '@mui/material';
import * as service from '../../services/service';

function AddMaterialIssue() {
    const [state, setState] = useState({ remarks: '' });
    const [issuedDate, setIssuedDate] = useState(new Date());
    // const [allocationData, setAllocationData] = useState([]);
    // const [subAssemblyMaterialData, setSubAssemblyMaterialData] = useState([]);    
    const [employeeData, setEmployeeData] = useState([]);
    const [employeeId, setEmployeeId] = useState('');
    const [productCatData, setProductCatData] = useState([]);
    const [productSubCatData, setProductSubCatData] = useState([]);
    const [productData, setProductData] = useState([]);
    const [subAssemblyData, setSubAssemblyData] = useState([]);
    const [partData, setPartData] = useState([]);
    const [productCatId, setProductCatId] = useState('');
    const [productSubCatId, setProductSubCatId] = useState('');
    const [productId, setProductId] = useState('');
    const [subAssemblyId, setSubAssemblyId] = useState('');
    const [partId, setPartId] = useState('');
    const [materialCategoryData, setMaterialCategoryData] = useState([]);
    const [materialSubCategoryData, setMaterialSubCategoryData] = useState([]);
    const [materialData, setMaterialData] = useState([]);
    const [materialCategoryId, setMaterialCategoryId] = useState('');
    const [materialSubCategoryId, setMaterialSubCategoryId] = useState('');
    const [materialIds, setMaterialIds] = useState([]);
    const [issuedQuantity, setIssuedQuantity] = useState([]);
    const [isSelected, setIsSelected] = useState([]);
    // const [availableQtyData, setAvailableQtyData] = useState([]);    
    const [issueFor, setIssueFor] = useState('');
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const selectStyles = { menu: styles => ({ ...styles, zIndex: 999 }) };
    const issueForData = [{ label: 'Sub Assembly/Part', value: 'Sub Assembly/Part' }, { label: 'Other', value: 'Other' }]
    const userDesignation = JSON.parse(sessionStorage.getItem('userData')).designation;
    // const [qty, setQty] = useState('');

    const getProductCategories = () => {
        fetch(
            service.PRODUCT_CATEGORY_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.productCategoryId, label: item.productCategory }));
                setProductCatData(data2);
            });
    };
    const getProductSubCategories = (id) => {
        fetch(
            service.PRODUCT_SUB_CATEGORY_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ProductCategoryId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.productSubCategoryId, label: item.productSubCategory }));
                setProductSubCatData(data2);
            });
    };

    const getProducts = (catId, subCatId) => {
        fetch(
            service.PRODUCT_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ProductCategoryId: catId,
                    ProductSubCategoryId: subCatId
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.productId, label: item.product }));
                setProductData(data2);
            });
    };
    const getSubAssemblies = (prodId) => {
        fetch(
            service.SUBASSEMBLY_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    ProductId: prodId
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.subAssemblyId, label: item.subAssembly }));
                setSubAssemblyData(data2);
            });
    };

    const getParts = (assemblyId) => {
        fetch(
            service.PART_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    SubAssemblyId: assemblyId
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.partId, label: item.part }));
                setPartData(data2);
            });
    };

    const getMaterialCategories = () => {
        fetch(
            service.MATERIAL_CATEGORY_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.materialCategoryId, label: item.materialCategory }));
                setMaterialCategoryData(data2);
            });
    };
    const getMaterialSubCategories = (id) => {
        fetch(
            service.MATERIAL_SUB_CATEGORY_URL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    materialCategoryId: id,
                })
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.materialSubCategoryId, label: item.materialSubCategory }));
                setMaterialSubCategoryData(data2);
            });
    };
    const getMaterials = (id) => {
        fetch(
            service.GET_MATERIAL_WITH_AVAILABLE_QTY,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    materialCategoryId: materialCategoryId.value,
                    materialSubCategoryId: id
                })
            })
            .then(res => res.json())
            .then(result => {
                setMaterialData(result);
                result.forEach((element, index) => {
                    materialIds[index] = element.materialId;
                    setMaterialIds([...materialIds]);
                    isSelected[index] = false;
                    setIsSelected([...isSelected]);
                    issuedQuantity[index] = 0;
                    setIssuedQuantity([...issuedQuantity]);
                });
            });
    };

    const getEmployees = () => {
        fetch(
            service.GET_ACTIVE_EMPLOYEES,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
            })
            .then(res => res.json())
            .then(result => {
                const data2 = result.map((item) => ({ value: item.employeeId, label: item.employeeName }));
                setEmployeeData(data2);
            });
    };

    const getSubAssemblyPartMaterial = (subId, parId) => {
        fetch(
            service.GET_SUBASSEMBLY_MATERIAL,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    SubAssemblyId: subId,
                    PartId: parId
                })
            })
            .then(res => res.json())
            .then(result => {
                if (result[0].message.messageType === "Failed") {
                    setMaterialData(null);
                }
                else {
                    setMaterialData(result);

                    result.forEach((element, index) => {
                        materialIds[index] = element.materialId;
                        setMaterialIds([...materialIds]);
                        isSelected[index] = false;
                        setIsSelected([...isSelected]);
                        issuedQuantity[index] = 0;
                        setIssuedQuantity([...issuedQuantity]);
                    });
                }
            })
            .catch(err => {
                if (err) {
                    setErrors(err);
                };
            });
    };

    // const getMaterialAvailableQuantity = (id) => {
    //     setLoading(true);
    //     fetch(
    //         service.GET_MATERIAL_AVAILABLE_QUANTITY,
    //         {
    //             method: 'POST',
    //             headers: {
    //                 'Accept': 'application/json',
    //                 'Content-Type': 'application/json'
    //             },
    //             body: JSON.stringify({
    //                 MaterialId: id,
    //             })
    //         })
    //         .then(res => res.json())
    //         .then(result => {
    //             if (result.message.messageType === "Success") {
    //                 setAvailableQtyData(result);
    //             }
    //             else {
    //                 setAvailableQtyData(null);
    //             }
    //         })
    //         .catch(err => {
    //             if (err) {
    //                 setErrors(err);
    //             };
    //         });
    //     setLoading(false);
    // };

    useEffect(() => {
        getProductCategories();
        getEmployees();
        getMaterialCategories();
    }, []);

    const validate = () => {
        let isValid = true;
        const errs = {};
        if (!issueFor) {
            isValid = false;
            errs[".issueFor"] = "Please select issue for";
        }
        if (issueFor.value === "Sub Assembly/Part" && !subAssemblyId) {
            isValid = false;
            errs[".subassembly"] = "Please select sub assembly/part";
        }
        if (issueFor.value === "Other" && !materialCategoryId) {
            isValid = false;
            errs[".materialCategoryId"] = "Please select material category";
        }
        if (issueFor.value === "Other" && !materialSubCategoryId) {
            isValid = false;
            errs[".materialSubCategoryId"] = "Please select material sub category";
        }
        if (!employeeId) {
            isValid = false;
            errs[".employee"] = "Please select issue to";
        }
        if (!issuedDate) {
            isValid = false;
            errs[".issuedDate"] = "Please enter issue date";
        }
        if (issuedDate && moment(issuedDate).format("MM/DD/YYYY") > moment(new Date()).format("MM/DD/YYYY")) {
            isValid = false;
            errs[".issuedDate"] = "Issue date can not be greater than today";
        }
        if (!isSelected.includes(true)) {
            isValid = false;
            errs[".materialId"] = "Please select material";
        }
        // if (!state.issuedquantity) {
        //     isValid = false;
        //     errs[".issuedquantity"] = "Please enter issue quantity";
        // }
        // if (issueFor.value === "Office Purpose" && state.issuedquantity && state.issuedquantity > availableQtyData.availableQuantity) {
        //     isValid = false;
        //     errs[".issuedquantity"] = "Issued Quantity can not be greater than available quantity";
        // }
        // if (issueFor.value === "Work Order" && qty && state.issuedquantity > qty) {
        //     isValid = false;
        //     errs[".issuedquantity"] = "Issued Quantity can not be greater than available quantity";
        // }

        setErrors(errs);
        return isValid;
    }
    const changeHandler = (event) => {
        setState({ ...state, [event.target.name]: event.target.value });
    };

    const handleCheckboxChange = (checked, index) => {
        let updatedObject = isSelected[index];
        updatedObject = checked;
        isSelected[index] = updatedObject;
        setIsSelected([...isSelected]);
    }

    const productCatChangeHandler = (ev) => {
        setProductCatId(ev);
        setProductSubCatId(null);
        setProductId(null);
        setSubAssemblyId(null);
        setPartId(null);
        getProductSubCategories(ev.value);
    }
    const productSubCatChangeHandler = (ev) => {
        setProductSubCatId(ev);
        setProductId(null);
        setSubAssemblyId(null);
        setPartId(null);
        getProducts(productCatId.value, ev.value);
    }
    const productChangeHandler = (ev) => {
        setProductId(ev);
        setSubAssemblyId(null);
        setPartId(null);
        getSubAssemblies(ev.value);
    }

    const subAssemblyChangeHandler = (ev) => {
        setSubAssemblyId(ev);
        setPartId(null);
        getParts(ev.value);
        getSubAssemblyPartMaterial(ev.value, 0);
    }
    const partChangeHandler = (ev) => {
        setPartId(ev);
        getSubAssemblyPartMaterial(subAssemblyId.value, ev.value);
    }

    const issueForChangeHandler = (ev) => {
        setIssueFor(ev);
        setMaterialCategoryId(null);
        setMaterialSubCategoryId(null);        
        setMaterialSubCategoryData([]);
        setMaterialIds([]);
        setMaterialData([]);
        setProductCatId(null);
        setProductSubCatId(null);
        setProductId(null);
        setSubAssemblyId(null);
        setPartId(null);        
        setProductSubCatData([]);
        setProductData([]);
        setSubAssemblyData([]);
        setPartData([]);
    }

    const employeeChangeHandler = (ev) => {
        setEmployeeId(ev);
    }
    const materialCategoryChangeHandler = (ev) => {
        setMaterialCategoryId(ev);
        setMaterialSubCategoryId(null);
        setMaterialIds([]);
        setMaterialData([]);
        getMaterialSubCategories(ev.value);
    }
    const materialSubCategoryChangeHandler = (ev) => {
        setMaterialSubCategoryId(ev);
        setMaterialIds([]);
        setMaterialData([]);
        getMaterials(ev.value);
    }
    const issueQuantityChangeHandler = (event, index) => {
        if (Number.isNaN(parseFloat(event.target.value))) {
            // eslint-disable-next-line
            alert("Please enter numbers only");
            event.target.value = ""; // eslint-disable-line no-param-reassign
        }
        else {
            let updatedObject = issuedQuantity[index];
            updatedObject = event.target.value;
            issuedQuantity[index] = updatedObject;
        }
        setIssuedQuantity([...issuedQuantity]);
    };

    const submitHandler = e => {
        e.preventDefault();
        // eslint-disable-next-line
        console.log(materialIds);
        // eslint-disable-next-line
        console.log(isSelected);
        let flag = true;
        const errs = {};
        setLoading(true);
        if (validate()) {
            // eslint-disable-next-line
            if (window.confirm("Do you really want to issue the quantity? You can't change it later...")) {
                materialIds.forEach((element, index) => {
                    if (isSelected[index] === true) {
                        fetch(
                            service.ADD_MATERIAL_ISSUE,
                            {
                                method: 'POST',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    MaterialId: element,
                                    IssuedQuantity: issuedQuantity[index],
                                    IssuedDate: moment(issuedDate).format("MM/DD/YYYY"),
                                    IssuedTo: employeeId.value,
                                    Remarks: state.remarks,
                                    AddedBy: JSON.parse(sessionStorage.getItem('userData')).employeeId,
                                    UpdatedBy: JSON.parse(sessionStorage.getItem('userData')).employeeId,
                                })
                            })
                            .then(res => res.json())
                            .then(result => {
                                if (result.messageType === 'Failed') {
                                    flag = false;
                                    // eslint-disable-next-line
                                    alert(result.message);
                                    // navigate('/supplier/suppliermaterialmap');
                                }
                                else {
                                    flag = false;
                                    errs[".invalid"] = result.message;
                                    setErrors(errs);
                                }
                            });
                    }
                });
                if (flag) {
                    setMaterialIds([]);
                    setIsSelected([]);
                    // eslint-disable-next-line
                    alert("Data Saved Successfully");
                    // navigate('/masters/operationmachinemap');
                    window.location.reload(false);
                }
            }
        }
        setLoading(false);
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                            >
                                <MDTypography variant="h6" color="white">
                                    Save Details
                                </MDTypography>
                            </MDBox>
                            <Card style={{ alignItems: 'center' }}>
                                <br />
                                <Table>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell style={{ fontSize: '12px' }}>
                                                <Select
                                                    options={issueForData}
                                                    name="issueFor"
                                                    value={issueFor}
                                                    onChange={issueForChangeHandler}
                                                    placeholder="Select For"
                                                    isSearchable
                                                    styles={selectStyles}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".issueFor"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align='left' style={{ fontSize: '12px' }}>
                                                <Select
                                                    name="productCategory"
                                                    options={productCatData} placeholder="Select Product Category"
                                                    value={productCatId}
                                                    onChange={productCatChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={issueFor.value === 'Other'}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".productcategory"]}</div>
                                            </TableCell>
                                            <TableCell align='left' style={{ fontSize: '12px' }}>
                                                <Select
                                                    name="productSubCategory"
                                                    options={productSubCatData} placeholder="Select Product Sub Category"
                                                    value={productSubCatId}
                                                    onChange={productSubCatChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={issueFor.value === 'Other'}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".productsubcategory"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align='left' style={{ fontSize: '12px' }}>
                                                <Select
                                                    name="product"
                                                    options={productData} placeholder="Select Product"
                                                    value={productId}
                                                    onChange={productChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={issueFor.value === 'Other'}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".product"]}</div>
                                            </TableCell>
                                            <TableCell align='left' style={{ fontSize: '12px' }}>
                                                <Select
                                                    name="subassembly"
                                                    options={subAssemblyData} placeholder="Select Sub Assembly"
                                                    value={subAssemblyId}
                                                    onChange={subAssemblyChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={issueFor.value === 'Other'}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".subassembly"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align='left' style={{ fontSize: '12px' }}>
                                                <Select
                                                    name="part"
                                                    options={partData} placeholder="Select Part"
                                                    value={partId}
                                                    onChange={partChangeHandler}
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={issueFor.value === 'Other'}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".part"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell align='left' style={{ fontSize: '12px', width: '30%' }}>
                                                <Select
                                                    options={materialCategoryData}
                                                    name="materialCategory"
                                                    value={materialCategoryId}
                                                    onChange={materialCategoryChangeHandler}
                                                    placeholder="Select Material Category"
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={issueFor.value === 'Sub Assembly/Part'}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".materialCategoryId"]}</div>
                                            </TableCell>
                                            <TableCell align='left' style={{ fontSize: '12px', width: '30%' }}>
                                                <Select
                                                    options={materialSubCategoryData}
                                                    name="materialSubCategory"
                                                    value={materialSubCategoryId}
                                                    onChange={materialSubCategoryChangeHandler}
                                                    placeholder="Select Material Sub Category"
                                                    isSearchable
                                                    styles={selectStyles}
                                                    isDisabled={issueFor.value === 'Sub Assembly/Part'}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".materialSubCategoryId"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell colSpan={3} align='center'>
                                                {loading ? <Oval
                                                    heigth="100"
                                                    width="100"
                                                    color='grey'
                                                    ariaLabel='loading'
                                                /> :
                                                    <TableContainer component={Paper} style={{ width: '95%', alignSelf: 'center', }}>
                                                        <Table aria-label="simple table">
                                                            <TableRow>
                                                                <TableCell style={{ fontWeight: 'bold' }}>Select</TableCell>
                                                                <TableCell style={{ fontWeight: 'bold' }}>Material Category</TableCell>
                                                                <TableCell style={{ fontWeight: 'bold' }}>Material Sub Category</TableCell>
                                                                <TableCell style={{ fontWeight: 'bold' }}>Material</TableCell>
                                                                <TableCell style={{ fontWeight: 'bold' }}>Required Quantity</TableCell>
                                                                <TableCell style={{ fontWeight: 'bold' }}>Available Quantity</TableCell>
                                                                <TableCell style={{ fontWeight: 'bold' }}>Issued Quantity</TableCell>
                                                            </TableRow>
                                                            {materialData ?
                                                                <TableBody>
                                                                    {materialData.map((row, index) => (
                                                                        <TableRow
                                                                            key={row.materialId}
                                                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                                        >
                                                                            <TableCell>
                                                                                <Checkbox checked={isSelected[index] || false}
                                                                                    onChange={(e) => handleCheckboxChange(e.target.checked, index)} id="chkSelect" />
                                                                            </TableCell>
                                                                            <TableCell>{row.materialCategory}</TableCell>
                                                                            <TableCell>{row.materialSubCategory}</TableCell>
                                                                            <TableCell>{row.material}</TableCell>
                                                                            <TableCell>{row.quantity}</TableCell>
                                                                            <TableCell>{row.availableQuantity}</TableCell>
                                                                            <TableCell>
                                                                                <MDInput label="Issued Quantity" fullWidth value={issuedQuantity[index] || ''}
                                                                                    name="issuedQuantity"
                                                                                    onChange={ev => issueQuantityChangeHandler(ev, index)}
                                                                                    id="issuedQuantity"
                                                                                />
                                                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".issuedQuantity"]}</div>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ))}
                                                                </TableBody>
                                                                : null}
                                                        </Table>
                                                        <div style={{ fontSize: '12px', color: 'red' }}>{errors[".materialId"]}</div>
                                                    </TableContainer>
                                                }
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <MDBox mb={2} style={{ fontSize: '14px' }}>
                                                    <Select
                                                        options={employeeData}
                                                        name="employee"
                                                        value={employeeId}
                                                        onChange={employeeChangeHandler}
                                                        placeholder="Select Employee"
                                                        isSearchable
                                                        styles={selectStyles}
                                                    />
                                                    <div style={{ fontSize: '12px', color: 'red' }}>{errors[".employee"]}</div>
                                                </MDBox>
                                            </TableCell>
                                            <TableCell>
                                                Issue Date
                                                <DatePicker
                                                    id="issuedDate"
                                                    selected={issuedDate}
                                                    onChange={date => setIssuedDate(date)}
                                                    dateFormat="MM/dd/yyyy"
                                                    tabIndex={0}
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".issuedDate"]}</div>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>
                                                <MDInput label="Remarks" fullWidth value={state.remarks || ''}
                                                    name="remarks"
                                                    onChange={changeHandler}
                                                    id="remarks"
                                                    required
                                                    multiline
                                                />
                                                <div style={{ fontSize: '12px', color: 'red' }}>{errors[".remarks"]}</div>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                                {userDesignation === 'General Manager' || userDesignation === 'Asst Mgr - Store'
                                    || userDesignation === 'Jr Mgr - Store' || userDesignation === 'Manager - Store'
                                    || userDesignation === 'Sr Mgr - Store' || userDesignation === 'MD' || userDesignation === 'Assistant - Store' ?
                                    <MDBox mt={4} mb={1} textAlign="center">
                                        {loading ? <Oval
                                            heigth="20"
                                            width="20"
                                            color='grey'
                                            ariaLabel='loading'
                                        /> :
                                            <MDButton color="info" onClick={submitHandler}>
                                                SAVE
                                            </MDButton>
                                        }
                                        {errors ? <div style={{ fontSize: '12px', color: 'red' }}>{errors[".invalid"]}</div> : null}
                                    </MDBox>
                                    : null}
                            </Card>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
            <Footer />
        </DashboardLayout>
    );
}

export default AddMaterialIssue;